import React, { useEffect } from 'react'
import { withRouter } from 'react-router'

import { writeStorage, deleteFromStorage } from '@rehooks/local-storage'

import Loader from 'common/components/Loader'
import { usePost } from 'common/hooks/useApi'
import { roles } from 'common/util/roles'

import { AuthEndpoint } from 'routes/locations/endpoints/auth'

const OauthComponent = ({ history }) => {
  const search = window.location.search
  const queryString = new URLSearchParams(search)
  const token = queryString.get('token')
  const path = queryString.get('path') || '/'
  const institutionId = queryString.get('institution_id')
  const versionId = queryString.get('version_id')

  const [login, ,] = usePost(AuthEndpoint.path)

  const tryLogin = async () => {
    try {
      const response = await login({ data: { token: token, institution_id: institutionId } })

      writeStorage('token', response.meta.headers['access-token'])
      writeStorage('Authorization', response.meta.headers['access-token'])
      writeStorage('client', response.meta.headers['client'])
      writeStorage('uid', response.meta.headers['uid'])

      const formatUserInfo = {
        data: {
          ...response.data,
          role: roles(response.data.role),
          roles: response.data.role,
        },
      }

      writeStorage('userInfo', formatUserInfo)

      history.push(path, { versionId })
    } catch (error) {
      history.push('/login')
      console.log(error)
    }
  }

  useEffect(() => {
    deleteFromStorage('token')
    deleteFromStorage('Authorization')
    deleteFromStorage('client')
    deleteFromStorage('uid')
    deleteFromStorage('userInfo')

    tryLogin()
  }, [])

  return <>{<Loader />}</>
}

export default withRouter(OauthComponent)
